<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="welcome-image"><span class="center"><a href="#/book001"><img alt="CoverImage" src="images/9780316209229_c.jpg" title="Cover"/></a></span></p></div>
<p class="welcome"><span class="center"><a href="#/book001"><strong>Begin Reading</strong></a></span></p>
<p class="welcome"><span class="center"><span href="#/toc" title="Link target outside of Sample">Table of Contents</span></span></p>
<p class="welcome"><span class="center"><span href="#/teaser001" title="Link target outside of Sample">A Preview of <em>Kingmaker, Kingbreaker</em></span></span></p>
<p class="welcome"><span class="center"><span href="#/newsletterSignup" title="Link target outside of Sample">Newsletters</span></span></p>
<p class="welcome"><span class="center"><span href="#/copyright" title="Link target outside of Sample">Copyright Page</span></span></p>
<p class="welcome1"><span class="center">In accordance with the U.S. Copyright Act of 1976, the scanning, uploading, and electronic sharing of any part of this book without the permission of the publisher constitute unlawful piracy and theft of the author’s intellectual property. If you would like to use material from the book (other than for review purposes), prior written permission must be obtained by contacting the publisher at permissions@hbgusa.com. Thank you for your support of the author’s rights.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// welcome.vue?c24fbdee